/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  fetchParticipation_candidat_seances({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participation_candidat_seance`)
        .then((response) => {
          commit('SET_Participation_candidat_seances', response.data)
          console.log('1',response.data)
          resolve(response)
        })
        
    })
  },
  fetchParticipation_candidat_seance_id({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participation_candidat_seance_id/${userId}`)
        .then((response) => {
          commit('SET_Participation_candidat_seances', response.data)
          console.log('20',response.data)
          resolve(response)
        })
        
    })
  },
  fetchParticipation_candidat_id_seance({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participation_candidat_id_seance/${userId}`)
        .then((response) => {
          commit('SET_Participation_candidat_seances', response.data)
          console.log('2',response.data)
          resolve(response)
        })
        
    })
  },
  addParticipation_candidat_seance({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/add_participation_candidat_seance", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        
    })
  },
   addItem({ commit }, item) {
     return new Promise((resolve, reject) => {
       axios.post("https://trainingcenterback.codily.net/api/addSeance", item)
         .then((response) => {
          //  console.log('item')
          //  alert( "1" )
           //commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          //  resolve(response)
         })
         
     })
   },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getSeance")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        
    })
  },
  fetchSeanceFormation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_seances_formation_id/${userId}`)
        .then((response) => {
          console.log('SET_USscccccccccccccccERS', response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        
    })
  },
  fetchUser({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/getSeanceId/${userId}`)
        .then((response) => {
          commit('SET_SEANCE', response.data)
          resolve(response)
        })
        
    })
  },
  
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroySeance/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        
    })
  },
  
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateSeance/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        
    })
  },
  updateParticipation_candidat_seance({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_participation_candidat_seance/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        
    })
  },
  ////////////////
  fetchSeancesFormaturId({ commit },formateurid) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_seance_formateur_id/${formateurid}`)
        .then((response) => {
          console.log('rr',formateurid)
          console.log('rr',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        
    })
  },
  ////////////////
  fetchSeancesCandidatParticipationId({ commit },item) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_seance_participation_candidat_id/${item.id}/${item.class_id}`)
        .then((response) => {
          // console.log('dd',formateurid,classid)
          console.log('dd',response.data)
          commit('SET_CANDIDAT_SEANCE', response.data)
          resolve(response)
        })
        
    })
  },
  fetchSeancesCandidatId({ commit },formateurid) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_seance_candidat_id/${formateurid}`)
        .then((response) => {
          
          commit('SET_USERS', response.data)
          resolve(response)
        })
        
    })
  },
  fetchSeancesCandidatIdFormationId({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_seance_candidat_formation_id/${obj.candidat}/${obj.formation}`)
        .then((response) => {
          
          console.log('rrddddddd',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        
    })
  },
  fetchParticipation_candidat_id_seance({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participation_candidat_id_seance/${userId}`)
        .then((response) => {
          commit('SET_Participation_candidat_seances', response.data)
          console.log('2',response.data)
          resolve(response)
        })
        
    })
  },
  fetchParticipation_candidat_id_seance_id({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participation_candidat_id_seance_id/${obj.candidat}/${obj.seance}`)
        .then((response) => {
          commit('SET_Participation_candidat_seances', response.data)
          console.log('1fgfgfg',response.data)
          
          resolve(response)
        })
        
    })
  },
  
}
